module.exports = __webpack_public_path__ + "img/manage-4.2b335d7e.png";